import { ScannerException } from './ScannerException';

export enum ErrorCode {
  GENERIC,
  CONNECTION,
  CONFIGURATION,
  DETECTION,
  DISCONNECTION,
}

export class ScannerConnectionException extends ScannerException {
  private static errorCodeMessages: Record<ErrorCode, string> = {
    [ErrorCode.GENERIC]: 'Error connecting to scanner.',
    [ErrorCode.CONFIGURATION]: 'No options configured for scanner {0}.',
    [ErrorCode.CONNECTION]: 'Error connecting to {0}.',
    [ErrorCode.DISCONNECTION]: 'Error disconnecting from {0}.',
    [ErrorCode.DETECTION]: 'Error detecting any {0}.',
  };

  public code: ErrorCode;

  constructor(
    errorCode: ErrorCode = ErrorCode.GENERIC,
    detectorName: string = ''
  ) {
    const errorMessage =
      ScannerConnectionException.errorCodeMessages[errorCode];
    if (
      errorCode === ErrorCode.CONNECTION ||
      errorCode === ErrorCode.DISCONNECTION ||
      errorCode === ErrorCode.CONFIGURATION ||
      errorCode === ErrorCode.DETECTION
    ) {
      super(errorMessage.replace('{0}', detectorName));
    } else {
      super(errorMessage);
    }

    this.code = errorCode;
  }
}
